import { fork } from 'redux-saga/effects';

import user from './users';
import subscribers from './users/subscribers';
import cargoesAssigners from './cargoes/assigners';
import cargoesGazetters from './cargoes/gazetters';
import cargoesTypes from './cargoes/types';
import cargoesDuplicates from './cargoes/duplicates';
import cargoesLdRates from './cargoes/ldRates';
import cargoesRealNames from './cargoes/realNames';
import cargoesNames from './cargoes/names';
import termEntities from './termEntities';
import letters from './letters';
import annotations from './annotations';
import gazetters from './gazetters';
import regionsPorts from './regions/ports';
import regionsAreas from './regions/areas';
import cargoesRequests from './cargoes/requests';
import vesselsRequests from './vessels/requests';
import mailRecognizeSpamList from './preferences/mailRecognizeSpamList';
import createFilterAnnotations from './preferences/filterAnnotations';
import preferences from './preferences/index';
import vesselsClaims from './vessels/claims';
import vesselsVessels from './vessels/vessels';
import contacts from './contacts';
import companies from './companies';
import realCompanies from './realCompanies';
import countries from './countries';
import statisticsUsers from './statistics/users';
import statisticsEmails from './statistics/emails';
import statisticsMonitor from './statistics/monitor';
import statisticsCargoRequests from './statistics/cargoRequests';
import statisticsVesselPositions from './statistics/vesselPositions';
import train from './train';
import sender from './sender';
import domains from './domains';
import backendNotifications from './notifications/backendNotifications';
import reqLDRates from './reqLDRates';
import gazetterTrainigs from './gazetterTrainings';
import integrators from './integrators/integrators';
// import tcOrders from "./tc/orders";
import tcRequests from './tc/requests';
import sales from './vessels/sales';
import linksList from './analytics/linksList';
import flagCompliance from './flagCompliance';
import tcIndexes from './tc/indexes';
import cargoTagsCategories from './cargoes/tags';
import issues from './issues';

const sagas = [
    ...user,
    ...cargoesAssigners,
    ...cargoesGazetters,
    ...cargoesTypes,
    ...cargoesDuplicates,
    ...cargoesLdRates,
    ...cargoesRealNames,
    ...cargoesNames,
    ...termEntities,
    ...letters,
    ...annotations,
    ...gazetters,
    ...preferences,
    ...regionsPorts,
    ...regionsAreas,
    ...cargoesRequests,
    ...sales,
    ...vesselsRequests,
    ...vesselsClaims,
    ...vesselsVessels,
    ...contacts,
    ...companies,
    ...realCompanies,
    ...countries,
    ...statisticsUsers,
    ...statisticsEmails,
    ...statisticsMonitor,
    ...statisticsCargoRequests,
    ...statisticsVesselPositions,
    ...train,
    ...mailRecognizeSpamList,
    ...createFilterAnnotations,
    ...sender,
    ...domains,
    ...subscribers,
    ...backendNotifications,
    ...reqLDRates,
    ...gazetterTrainigs,
    ...integrators,
    // ...tcOrders,
    ...tcRequests,
    ...linksList,
    ...flagCompliance,
    ...tcIndexes,
    ...cargoTagsCategories,
    ...issues,
];

export default function* rootSaga() {
    try {
        yield sagas.map(saga => fork(saga));
    } catch (error) {
        console.error('Global async error -', error);
        return error;
    }
}



// WEBPACK FOOTER //
// ./app/sagas/index.js